

export function updateMaintenance($route, $store, $router, applicationSettings) {
    // return
    if (applicationSettings) {
        if (applicationSettings.maintenance && $route.name !== 'maintenance') {
            $store.commit("updateMaintenance", true);
            $router.push({ name: 'maintenance' })
        } else if (!applicationSettings.maintenance && $route.name === 'maintenance') {
            $store.commit("updateMaintenance", false);
            $router.push({ name: 'home' })
        }
    }
}
